import { apiRequest } from "../client";

export interface ChatContextConfig {
    is_active: boolean;
    initial_assistant_message: string;
    sample_prompts: string[];
}

export interface ChatContextsResponse {
    company_id: string;
    contexts: Record<string, ChatContextConfig>;
}

export interface ChatContextsUpdate {
    contexts: Record<string, ChatContextConfig>;
}

/**
 * Get all chat context configurations for the current user's company
 */
export async function getChatContexts(): Promise<ChatContextsResponse> {
    return apiRequest<ChatContextsResponse>({
        method: "GET",
        url: "/ani-experts/chat-contexts"
    });
}

/**
 * Update all chat context configurations for the current user's company
 */
export async function updateChatContexts(data: ChatContextsUpdate): Promise<ChatContextsResponse> {
    return apiRequest<ChatContextsResponse>({
        method: "PUT",
        url: "/ani-experts/chat-contexts",
        data
    });
}

/**
 * Get a specific chat context configuration
 */
export async function getChatContext(contextName: string): Promise<ChatContextConfig> {
    return apiRequest<ChatContextConfig>({
        method: "GET",
        url: `/ani-experts/chat-contexts/${contextName}`
    });
}

/**
 * Update a specific chat context configuration
 */
export async function updateChatContext(contextName: string, config: ChatContextConfig): Promise<ChatContextConfig> {
    return apiRequest<ChatContextConfig>({
        method: "PUT",
        url: `/ani-experts/chat-contexts/${contextName}`,
        data: config
    });
} 